import { render, staticRenderFns } from "./AppLoader.vue?vue&type=template&id=7b23ab44&scoped=true&"
import script from "./AppLoader.vue?vue&type=script&lang=js&"
export * from "./AppLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b23ab44",
  null
  
)

export default component.exports